// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__I3LEL","choiceBoxes":"toolbarselects_choiceBoxes__HZeQx","simpleField":"toolbarselects_simpleField__g3GGp"};